type Props = {
  employeeId: string | null | undefined;
};

export default function EmployeeIdLabel({ employeeId }: Props) {
  const normalized = employeeId?.trim();

  return (
    <>
      {normalized ? `Emp # ${normalized}` : "Emp ID not assigned"}
    </>
  );
}